module.exports = __webpack_public_path__ + "img/horizontal_6_1_8004.fd499c5d.png";